import { render, staticRenderFns } from "./InvestigationDetail.vue?vue&type=template&id=479dc0ff&scoped=true&"
import script from "./InvestigationDetail.vue?vue&type=script&lang=js&"
export * from "./InvestigationDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationDetail.vue?vue&type=style&index=0&id=479dc0ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479dc0ff",
  null
  
)

export default component.exports